var _rect, _ellipse, _path, _path2, _path3, _circle, _circle2, _circle3, _path4, _path5, _path6, _circle4, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocAIbot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 59.1067,
    width: 57.8318,
    height: 83.5895,
    rx: 28.9159,
    transform: "rotate(45 59.1067 0)",
    fill: "#FCE9DB"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.892,
    cy: 62.4781,
    rx: 16.9335,
    ry: 15.1511,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.7413 26.811H58.2023C62.0683 26.811 65.2023 29.945 65.2023 33.811V48.2144C65.202 51.56 62.4903 54.2717 59.1447 54.272H58.4005L58.1866 54.9849L56.7706 59.7036L50.255 54.4917L49.9816 54.272H44.7413C40.8753 54.272 37.7413 51.138 37.7413 47.272V33.811C37.7413 29.945 40.8753 26.811 44.7413 26.811Z",
    fill: "white",
    stroke: "#F37D21",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7066 44.5312C55.5393 46.5493 53.3574 47.907 50.8583 47.907C49.8743 47.907 48.9394 47.6965 48.0963 47.318",
    stroke: "#F37D21",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0696 64.5135H68.0618C72.8125 64.5137 76.1828 69.1453 74.7219 73.6659L73.5608 77.2606C72.627 80.1502 69.9364 82.1083 66.8997 82.1083H36.3762C33.4325 82.1083 30.8029 80.2665 29.7971 77.4999L28.4905 73.9052C26.8309 69.34 30.2121 64.5135 35.0696 64.5135Z",
    fill: "#FFDCC1",
    stroke: "#F37D21",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 56.3822,
    cy: 36.8589,
    r: 1,
    fill: "#5567D5",
    stroke: "#F37D21",
    strokeWidth: 1.68267
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 51.4721,
    cy: 72.458,
    r: 1.84133,
    fill: "#F37D21"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.5615,
    cy: 36.8589,
    r: 1,
    fill: "#5567D5",
    stroke: "#F37D21",
    strokeWidth: 1.68267
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4993 21.2418C70.4993 19.3586 72.0259 17.8319 73.9091 17.8319H82.6579C84.7564 17.8319 86.4575 19.533 86.4575 21.6315V25.1075C86.4575 27.8689 84.2189 30.1075 81.4575 30.1075H75.4095H75.3824H74.9887C73.8058 30.1075 72.7874 30.9424 72.5554 32.1022L72.5033 32.363C72.4087 32.8359 71.9934 33.1763 71.5111 33.1763C70.9523 33.1763 70.4993 32.7233 70.4993 32.1645V21.2418Z",
    fill: "#FFB983"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6931 51.5896C25.6931 50.2337 24.5939 49.1345 23.238 49.1345H16.808C15.2745 49.1345 14.0313 50.3777 14.0313 51.9111V53.5537C14.0313 55.9944 16.0099 57.9729 18.4505 57.9729H22.1049H22.1247H22.4335C23.2862 57.9729 24.0209 58.5735 24.1905 59.4092L24.2271 59.5894C24.2972 59.9345 24.6006 60.1825 24.9527 60.1825C25.3616 60.1825 25.6931 59.851 25.6931 59.4421V51.5896Z",
    fill: "#FFB983"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6618 42.3829H35.5241C33.3149 42.3829 31.524 40.5921 31.524 38.3829V31.2004",
    stroke: "#F37D21",
    strokeWidth: 2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.5245,
    cy: 29.8005,
    r: 1.762,
    stroke: "#F37D21",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1891 64.1892C64.1891 60.4781 62.6955 57.1253 60.2919 54.7297M38.5134 64.1892C38.5134 60.4781 40.007 57.1253 42.4106 54.7297",
    stroke: "#F37D21",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5722 60.7963L41.3446 63.5583",
    stroke: "#F37D21",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocAIbot);
export default __webpack_public_path__ + "static/media/DocAIbot.c7fe52fafef650776b69284ca5541116.svg";
export { ForwardRef as ReactComponent };